import React, { useEffect } from 'react';
import Profile from 'features/profile/Profile';
import { handleFooterElementDisplay, handleMainElementDisplay, LoadStatus } from '../config/utils';
import FullPageLoader from 'components/FullPageLoader';
import { useAppSelector } from 'app/hooks';
import { accountStore } from 'features/account/stores/account.slice';
import { stripeStore } from '../features/checkout/stores/stripe.slice';

export default function AccountPage() {
   const { addStripeBillingStatus, stripeLoading } = useAppSelector(stripeStore);
   const { updateBillingAddressStatus, fetchBillingProfilesStatus, defaultBillingStatus, deleteBillingStatus } =
      useAppSelector(accountStore);
   const isLoading =
      deleteBillingStatus === LoadStatus.loading ||
      defaultBillingStatus === LoadStatus.loading ||
      addStripeBillingStatus === LoadStatus.loading ||
      stripeLoading === LoadStatus.loading ||
      fetchBillingProfilesStatus === LoadStatus.loading ||
      updateBillingAddressStatus === LoadStatus.loading;

   useEffect(() => {
      handleMainElementDisplay(false);
      handleFooterElementDisplay(true);
   }, []);

   return (
      <>
         <FullPageLoader loading={isLoading} />
         <Profile />
      </>
   );
}
